import { OrthographicCamera } from '@react-three/drei'
import { useThree } from '@react-three/fiber'
import { type PropsWithChildren, useEffect } from 'react'

export function RenderTextureScene({ children }: PropsWithChildren) {
  const { gl } = useThree()
  useEffect(() => {
    gl.setClearAlpha(0)
  }, [gl])

  return (
    <>
      <OrthographicCamera
        makeDefault
        zoom={1}
        position-z={1}
        manual
        left={-10}
        right={10}
        top={10}
        bottom={-10}
      />
      <ambientLight intensity={2} />
      <directionalLight position={[5, 10, 5]} intensity={1.5} />

      {children}
    </>
  )
}
